import { Snackbar, SnackbarContent } from "@mui/material";
import { t } from "@lingui/macro";
import useVitalSummarySyncing from "./useVitalSummarySyncing";

// Its own component so the sync state only re-renders the toast, not the screen that hosts it.
// Mirrors the route sync toast in lobby-mfe: open for as long as the sync is, and gone on its own
// afterwards. Hosted only on the recovery-source flavour of the Authorized apps screen (the host
// gates it on import_vitals).
const VitalSummarySyncToast = () => {
  const vitalSummarySyncing = useVitalSummarySyncing();

  return (
    <Snackbar
      open={vitalSummarySyncing}
      anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
      sx={{ bottom: "calc(var(--wf-bottom-safe-area, 0px) + 8px)" }}
    >
      <SnackbarContent message={t`Syncing your health data...`} />
    </Snackbar>
  );
};

export default VitalSummarySyncToast;
